module.exports = __webpack_public_path__ + "img/valuationResultsData.31ece5a5.png";